<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        @if (modeService.isIosMode()) {
        <div>Zurück</div>
        } @if (!modeService.isIosMode()) {
        <div>
          <ion-icon
            name="arrow-back-outline"
            slot="icon-only"
            size="medium"
          ></ion-icon>
        </div>
        }
      </ion-button>
    </ion-buttons>
    <ion-title>Vorschau</ion-title>
    @if (invoiceAddRequest() || paymentAddRequest()) {
      <ion-buttons slot="end">
        <ion-button id="popover-button" [strong]="true">
          <ion-icon name="send-outline" slot="icon-only" size="small"></ion-icon>
        </ion-button>
      </ion-buttons>
    } @else if (isSharePluginAvailable) {
      <ion-buttons slot="end">
        <ion-button (click)="sharePdf()" [strong]="true">
          <ion-icon name="share-social-outline" slot="icon-only" size="small"></ion-icon>
        </ion-button>
      </ion-buttons>
    } @else {
      <ion-buttons slot="end">
        <ion-button (click)="downloadPdf()" [strong]="true">
          <ion-icon name="download-outline" slot="icon-only" size="small"></ion-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>
</ion-header>
<ion-content>
  <pinch-zoom class="h-full w-full" listeners="auto" wheel="false" [disabled]="isDesktop" [backgroundColor]="'#f7f7f7'">
    <pdf-viewer
      #pdfViewer
      [src]="pdfSrc()"
      [render-text]="false"
      [original-size]="false"
      style="
        width: 100%;
        height: calc(100% - 2rem);
        background: #f7f7f7;
        margin: 1rem 0;
      "
    ></pdf-viewer>
  </pinch-zoom>
</ion-content>

<ion-popover trigger="popover-button" [dismissOnSelect]="true">
  <ng-template>
    <ion-content>
      <ion-list>
        <ion-item
          [button]="true"
          [detail]="false"
          lines="full"
          (click)="openMailDialog()"
          >Als E-Mail versenden</ion-item
        >
        <ion-item
          [button]="true"
          [detail]="false"
          lines="full"
          (click)="downloadPdf()"
          >PDF herunterladen</ion-item
        >
        <ion-item [button]="true" [detail]="false" lines="none" (click)="save()"
          >Abschliessen</ion-item
        >
      </ion-list>
    </ion-content>
  </ng-template>
</ion-popover>
